<template>
  <div class="trainer-bio">
    <h3>
      <strong>{{ company.name }}</strong>
    </h3>
    <p v-if="!!company.address" class="m-0" v-html="company.address"></p>
    <p v-if="!!company.map_address">
      <a
        :href="`https://maps.google.com/maps?q=${company.map_address}`"
        target="_blank"
        class="text-primary"
        >View Map</a
      >
    </p>
    <template v-if="!!company.bio">
      <div class="company-bio" v-html="company.bio"></div>
      <div>
        <a class="btn btn-primary mb-3" :href="company.url">View Full Bio</a>
      </div>
    </template>
    <template v-if="!!company.trainers">
      <hr />
      <h3 class="text-center mb-4"><strong>Our Trainers</strong></h3>
      <div v-for="(trainer, i) in company.trainers" :key="i">
        <hr v-if="i > 0" />
        <div class="details-pane-table">
          <div class="row mb-2">
            <div class="col-4 col-attribute">Name:</div>
            <div class="col-8 col-value">
              <a :href="company.url" class="text-primary">{{ trainer.name }}</a>
            </div>
          </div>
          <div v-if="!!trainer.email" class="row mb-2">
            <div class="col-4 col-attribute">Email:</div>
            <div class="col-8 col-value">{{ trainer.email }}</div>
          </div>
          <div v-if="!!trainer.phone" class="row mb-2">
            <div class="col-4 col-attribute">Phone:</div>
            <div class="col-8 col-value">{{ trainer.phone }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    company: { type: Object, required: true },
  },
};
</script>